export const hasRole = (user, ...roles) => {
  const own = user?.roles?.length ? user.roles : [user?.role || "member"];
  return roles.some((r) => own.includes(r));
};
